<template>
  <div>
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li class="is-active">
          <a href="#" aria-current="page">Users to flag</a>
        </li>
      </ul>
    </nav>

    <transition name="page">
      <section v-if="loaded">
        <div class="card">
          <div class="card-content">
            <b-field
              grouped
              v-if="users.length"
              position="is-right">
              <b-select v-model="perPage">
                <option value="5">5 per page</option>
                <option value="10">10 per page</option>
                <option value="15">15 per page</option>
                <option value="20">20 per page</option>
              </b-select>
            </b-field>

            <b-table
              :data="users"
              :per-page="perPage"
              :loading="isLoading"
              :paginated="!!users.length"
              hoverable>
              <template slot-scope="props">
                <b-table-column field="name" label="Name" sortable>
                  {{ props.row.name }}
                </b-table-column>

                <b-table-column field="nickname" label="Nickname" sortable>
                  {{ props.row.nickname }}
                </b-table-column>

                <b-table-column field="email" label="Email" sortable>
                  {{ props.row.email }}
                </b-table-column>

                <b-table-column field="actions" width="40">
                  <b-dropdown position="is-bottom-left">
                    <button class="button is-info" slot="trigger">
                        <b-icon icon="menu-down"></b-icon>
                    </button>

                    <b-dropdown-item has-link>
                      <a @click.prevent.stop="showBanModal(props.row)">Ban</a>
                      <a @click.prevent.stop="unbanUser(props.row)">UnBan</a>
                    </b-dropdown-item>
                  </b-dropdown>
                </b-table-column>
              </template>

              <template slot="empty">
                <section class="section">
                  <div class="content has-text-grey has-text-centered">
                    <p>
                      <b-icon
                        icon="emoticon-sad"
                        size="is-large">
                      </b-icon>
                    </p>
                    <p>Nothing here.</p>
                  </div>
                </section>
              </template>
            </b-table>
          </div>
        </div>
      </section>
    </transition>

    <b-modal :active.sync="isBanModalActive" has-modal-card>
      <div class="card">
        <div class="card-content text-center">
          <span class="z-exclamation-outline is-size-2 text-red mb-2"></span>
          <p class="font-medium text-xl">Are you sure you want to flag the record?</p>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item font-bold text-red hover:text-red-light" @click="banUser">Yes, I'm sure</a>
          <a class="card-footer-item font-bold text-blue hover:text-blue-light" @click="isBanModalActive = false">Cancel</a>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'userspending',
  data: () => ({
    isBanModalActive: false,
    loaded: false,
    perPage: 10,
    selectedUser: {},
  }),
  computed: {
    ...mapState({
      isLoading: state => state.userspending.isLoading,
      users: state => state.userspending.all,
    })
  },
  async created() {
    await this.fetch();
    this.loaded = true;
  },
  methods: {
    ...mapActions('userspending', ['fetch', 'ban', 'unban']),

    showBanModal(user) {
      this.selectedUser = user;
      this.isBanModalActive = true;
    },

    async banUser() {
      this.isBanModalActive = false;
      await this.ban(this.selectedUser);
    },

    async unbanUser(user) {
      await this.unban(user);
    },
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/UsersPending.vue